import { useMutation, useQueryClient } from "react-query";

import { deleteEmployeesGroup } from "./index";

const useOnSuccess = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-employees-groups"] });
  };
};

export const useDeleteEmployeesGroup = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["delete-employees-group"], deleteEmployeesGroup, {
    onSuccess,
  });
};
